
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {IWhatsappTemplate, IWhatsappTemplateSend} from '@/model/Helpdesk/IWhatsapp';

// E.164 without symbols: country code + number, 8 to 15 digits.
const PHONE_DIGITS = /^[1-9]\d{7,14}$/;

const keyOf = (t: IWhatsappTemplate) => t.name + '|' + t.language;

// Picks an approved Meta template and fills its variables. With `new-conversation` it also asks
// for the phone: a business can only open a chat with a template.
@Component({name: 'WhatsappTemplateDialog'})
export default class WhatsappTemplateDialog extends Vue {
  @Prop({required: true}) open!: boolean;
  @Prop({required: true}) templates!: IWhatsappTemplate[];
  @Prop({type: Boolean, default: false}) loading!: boolean;
  @Prop({type: Boolean, default: false}) saving!: boolean;
  @Prop({type: Boolean, default: false}) newConversation!: boolean;

  valid = false;
  phone = '';
  name = '';
  selectedKey: string | null = null;
  parameters: string[] = [];

  get templateItems() {
    return this.templates.map((t) => ({text: t.name + ' (' + t.language + ')', value: keyOf(t)}));
  }

  get selected(): IWhatsappTemplate | null {
    return this.templates.find((t) => keyOf(t) === this.selectedKey) || null;
  }

  // {{1}}, {{2}}… replaced by what has been typed so far.
  get preview(): string {
    if (!this.selected) return '';
    return this.selected.body.replace(/\{\{(\d+)\}\}/g, (match, n) => this.parameters[Number(n) - 1] || match);
  }

  phoneRule(v: string) {
    return PHONE_DIGITS.test(this.digits(v)) || this.$t('helpdesk.whatsapp.templates.invalidPhone');
  }

  @Watch('open')
  onOpen(open: boolean) {
    if (!open) return;
    this.phone = '';
    this.name = '';
    this.selectedKey = null;
    this.parameters = [];
    this.$nextTick(() => {
      const form = this.$refs.form as any;
      if (form) form.resetValidation();
    });
  }

  @Watch('selectedKey')
  onTemplateChange() {
    const count = this.selected ? this.selected.parameters_count : 0;
    this.parameters = Array.from({length: count}, () => '');
  }

  close() {
    this.$emit('update:open', false);
  }

  submit() {
    const form = this.$refs.form as any;
    if (!this.selected || !form.validate()) return;
    const template: IWhatsappTemplateSend = {
      name: this.selected.name,
      language: this.selected.language,
      parameters: this.parameters.map((p) => p.trim()),
    };
    if (this.newConversation) {
      this.$emit('submit', {phone: this.digits(this.phone), name: this.name.trim() || undefined, template});
    } else {
      this.$emit('submit', {template});
    }
  }

  private digits(v: string): string {
    return (v || '').replace(/\D/g, '').replace(/^00/, '');
  }
}
